import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';
import { TourTagViewModel } from '@api/versions/v2/models/TourTagViewModel';
import Markdown from '@components/utils/Markdown';

import {
  ItemWrapper,
  IconWrapper,
  ItemText,
  TooltipContainer,
  ListingItemsWrapper,
  Title,
  Description,
  ListDesc,
  LogoTextWrapper,
} from './styled';

interface Props {
  segment: TourTagViewModel;
}
const Segments = ({ segment }: Props) => {
  const { palette } = useTheme();
  return (
    <TooltipContainer>
      <Tooltip
        getPopupContainer={(triggerNode) => triggerNode}
        trigger='hover'
        borderRadius='8px'
        overlayInnerStyle={{
          maxHeight: '190px',
          overflow: 'auto',
          borderRadius: '8px',
          border: 'none',
          backgroundColor: palette.white,
          width: '250px',
        }}
        placement='bottomLeft'
        arrowColor={palette.white}
        title={
          <ListingItemsWrapper>
            <Title badgeColor={segment.color}>{segment.name}</Title>
            <Description>{segment.shortDescription}</Description>
            <Title badgeColor={palette.D500}>Paket Özellikleri:</Title>
            <LogoTextWrapper>
              <ListDesc>
                <Markdown segment={true} text={segment.description || ''} />
              </ListDesc>
            </LogoTextWrapper>
          </ListingItemsWrapper>
        }
      >
        <ItemWrapper badgeColor={segment.color}>
          <IconWrapper>
            <CustomIcon
              paletteColor='white'
              icon={InfoIcon}
              width={16}
              height={16}
            />
          </IconWrapper>
          <ItemText>{segment.name}</ItemText>
        </ItemWrapper>
      </Tooltip>
    </TooltipContainer>
  );
};

export default Segments;
